/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const SiteReferrerState = Record({
  id: null,
  name: '',
  available_types: [],
  notations: []
})

export { SiteReferrerState }
